module.exports = __webpack_public_path__ + "604af6c53871854670c932a75642821c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/mummy-head-s.png
// module id = 2314
// module chunks = 0